import { Button } from '@/app/components/Button'
import { TRACKING_LOCATIONS, TrackingLocation } from '@/app/utils/analytics'

type BackToHomeButtonProps = {
  tracking?: TrackingLocation
  className?: string
  /** Where the button goes; defaults to the site home */
  href?: string
  label?: string
  dataId?: string
}

export function BackToHomeButton({
  tracking = { location: TRACKING_LOCATIONS.PAGE_CONTENT },
  className,
  href = '/',
  label = 'Back to home',
  dataId = 'backToHome',
}: BackToHomeButtonProps) {
  const buttonData = {
    _type: 'button' as const,
    variant: 'primary' as const,
    size: 'md' as const,
    themeMode: 'dark' as const,
    iconPlacement: 'none' as const,
    icon: null,
    dataId,
    link: {
      _type: 'link' as const,
      linkType: 'internal' as const,
      label,
      href,
      external: null,
      openInNewTab: false,
      ariaLabel: null,
      mailto: null,
      tel: null,
      anchor: null,
      internalPage: null,
      internalPost: null,
    },
  }

  return <Button button={buttonData} tracking={tracking} className={className} />
}
